export default __webpack_public_path__ + "static/media/heart.c759f248.svg";